<template>
  <div>
    <el-card class="mb5">
      <el-form :inline="false" label-position="top" size="small">
        <el-row :gutter="10">
          <el-col :span="5">
            <!--  车牌号   -->
            <el-form-item :label="$t('GlobalSetObj.licensePlateNumber')">
              <el-select
                v-model="queryForm.params.vehicleNumber"
                :placeholder="$t('GlobalSetObj.OnlyAreDisplayed')"
                :remote-method="getVehicleNumber"
                clearable
                filterable
                remote
                reserve-keyword
                size="small"
                style="width: 100%"
                @clear="getVehicleNumber('')"
                @focus="getVehicleNumber1"
              >
                <el-option
                  v-for="item in vehicleNumberList"
                  :key="item"
                  :label="item"
                  :value="item"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="5">
            <el-form-item :label="$t('scripting.nextStationHub')">
              <!-- 下一站网点 -->
              <el-select
                v-model="queryForm.params.nextSiteIdList"
                :placeholder="$t('GlobalSetObj.OnlyAreDisplayed')"
                :remote-method="remoteGetSiteList"
                clearable
                collapse-tags
                filterable
                multiple
                remote
                reserve-keyword
                style="width: 100%"
                @clear="remoteGetSiteList('')"
                @focus="remoteGetSiteList('', true)"
              >
                <el-option
                  v-for="item in siteList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="5">
            <el-form-item :label="$t('scripting.returnCode')">
              <!-- 退件码 -->
              <el-select
                v-model="queryForm.params.returnCode"
                :placeholder="$t('GlobalSetObj.OnlyAreDisplayed')"
                :remote-method="getReturnCodeList"
                clearable
                filterable
                remote
                reserve-keyword
                size="small"
                style="width: 100%"
                @clear="getReturnCodeList('')"
                @focus="getReturnCodeList1"
              >
                <el-option
                  v-for="item in returnCodeList" :key="item" :label="item"
                  :value="item"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="9" style="margin-top: 27px">
            <el-button
              icon="el-icon-search" size="small" type="primary"
              @click="enterSearch"
            >{{ $t('newOrder.search') }}
            </el-button>
            <!--重置-->
            <el-button
              icon="el-icon-refresh-left" size="small" type="info"
              @click="resetForm"
            >{{ $t('newOrder.reset') }}
            </el-button>
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col :span="19">
            <el-form-item>
              <!-- 打印 -->
              <el-button
                size="small" type="primary" @click="clickPrint"
              >{{ $t('scripting.printReturnCode') }}
              </el-button>
              <!-- 导出PDF -->
              <el-button
                size="small" @click="generateReturnCode"
              >{{ $t('scripting.generateReturnCode') }}
              </el-button>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </el-card>
    <el-card>
      <!--  表格数据  -->
      <el-table
        :cell-style="{ 'text-align': 'center' }"
        :data="tableData"
        :header-cell-style="{ background: '#f2f2f2', color: 'black', 'text-align': 'center' }"
        border
        style="width: 100%"
      >
        <el-table-column :label="$t('GlobalSetObj.serial')" type="index" width="80" />
        <el-table-column :label="$t('GlobalSetObj.LoadCarTime')" min-width="180" prop="loadTime" />
        <el-table-column
          :label="$t('GlobalSetObj.licensePlateNumber')"
          min-width="180"
          prop="vehicleNumber"
        />
        <el-table-column
          :label="$t('scripting.nextStationHub')"
          min-width="180"
          prop="nextSiteIdName"
        />
        <el-table-column :label="$t('scripting.returnCode')" min-width="150" prop="returnCode" />
        <el-table-column :label="$t('seller.expirationTime')" min-width="150" prop="abortTime" />
      </el-table>
      <!--  分页  -->
      <el-pagination
        :current-page="queryForm.pageNumber"
        :page-size="queryForm.pageSize"
        :page-sizes="[10, 20, 50, 100]"
        :total="queryForm.total"
        background
        layout="total, sizes, prev, pager, next, jumper"
        style="margin: 10px 0; float: right"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      />
    <!--打印大包号-->
    </el-card>
    <div class="printStyle">
      <returnCodeHtml
        v-if="showPrintReturnCodeHtml"
        :param-data="paramDataList"
        @hiddenBagNumberHtml="hiddenBagNumberHtml"
      />
    </div>
    <addReturnCode ref="addReturnCodeRef" :next-site-list="nextSiteList" @search="childrenSearch" />
    <printReturnCodeCom ref="printReturnCodeRef" @printReturnCode="printReturnCodeFun" />
  </div>
</template>

<script>
import { queryReturnCode, returnCodePage } from '@/api/storeAdmin';
import { getAllsite } from '@/api/logisticsOrders';
import { vehicleTagNumber } from '@/api/orderApi';
import returnCodeHtml from './component/returnCodeHtml.vue';
import addReturnCode from './component/addReturnCode.vue';
import printReturnCodeCom from './component/printReturnCode.vue';
import { siteFuzzyQuery } from '@/api/lanshou';

export default {
  name: 'LoadingDocument',
  components: {
    returnCodeHtml,
    addReturnCode,
    printReturnCodeCom
  },
  data() {
    return {
      // 是否格式化成巴西时间
      showPrintReturnCodeHtml: false,
      paramDataList: [],
      isTormat: false,
      zhDate: 'yyyy-MM-dd HH:mm:ss',
      ptDate: 'dd-MM-yyyy HH:mm:ss',
      timeValue: [],
      queryForm: {
        pageSize: 10,
        pageNumber: 1,
        total: 0,
        params: {
          vehicleNumber: '',
          nextSiteIdList: [],
          returnCode: ''
        }
      },
      vehicleNumberList: [], // 车签号
      tableData: [],
      nextSiteList: [],
      returnCodeList: [],
      siteList: []
    };
  },
  created() {
    if (this.$i18n.locale !== 'zh') {
      this.isTormat = true;
    }
    this.getVehicleNumber('');
    this.getSearch();
    this.getNextSite();
    this.getReturnCodeList('');
  },
  methods: {
    remoteGetSiteList(val, flag) {
      const value = val || '';
      if (flag) {
        if (this.siteList.length === 0) {
          siteFuzzyQuery(value).then((res) => {
            if (res.code === 200) {
              this.siteList = res.data;
            }
          });
        }
      } else {
        siteFuzzyQuery(value).then((res) => {
          if (res.code === 200) {
            this.siteList = res.data;
          }
        });
      }
    },
    // 下拉搜索退件码
    getReturnCodeList(val) {
      queryReturnCode(val).then((res) => {
        if (res.code === 200) {
          this.returnCodeList = res.data;
        }
      });
    },
    getReturnCodeList1() {
      if (this.returnCodeList.length === 0) {
        queryReturnCode('').then((res) => {
          if (res.code === 200) {
            this.returnCodeList = res.data;
          }
        });
      }
    },
    // 获取下一站网点
    getNextSite() {
      getAllsite().then((res) => {
        if (res.code === 200) {
          this.nextSiteList = res.data;
        }
      });
    },
    // 清空打印袋号数据
    hiddenBagNumberHtml() {
      this.showPrintReturnCodeHtml = false;
      this.resetForm();
    },
    enterSearch() {
      this.queryForm.pageNumber = 1;
      this.getSearch();
    },
    childrenSearch() {
      this.enterSearch();
    },
    generateReturnCode() {
      this.$refs.addReturnCodeRef.showAddDialog();
    },
    // 点击打印
    clickPrint() {
      this.$refs.printReturnCodeRef.showAddDialog();
    },
    printReturnCodeFun(data) {
      this.paramDataList = data;
      if (this.paramDataList.length === 0) {
        this.$message.error(this.$t('scripting.noAvailableReturnCode'));
        return;
      }
      this.showPrintReturnCodeHtml = true;
    },
    // 重置
    resetForm() {
      this.paramDataList = [];
      this.queryForm.params = {
        vehicleNumber: '',
        nextSiteIdList: [],
        returnCode: ''
      };
      this.enterSearch();
      this.getVehicleNumber('');
      this.getReturnCodeList('');
      this.remoteGetSiteList('');
    },
    // 查询
    getSearch() {
      const data = {
        pageSize: this.queryForm.pageSize,
        pageNumber: this.queryForm.pageNumber,
        params: {
          vehicleNumber: this.queryForm.params.vehicleNumber,
          nextSiteIdList: this.queryForm.params.nextSiteIdList,
          returnCode: this.queryForm.params.returnCode
        }
      };
      returnCodePage(data).then((res) => {
        if (res.code === 200) {
          this.queryForm.total = res.data.total;
          this.tableData = res.data.records;
        }
      });
    },
    // 点击分页
    handleSizeChange(val) {
      this.queryForm.pageSize = val;
      this.queryForm.pageNumber = 1;
      this.getSearch();
    },
    handleCurrentChange(val) {
      this.queryForm.pageNumber = val;
      this.getSearch();
    },
    // 车牌号
    getVehicleNumber(val) {
      console.log(val, 'getVehicleNumber0111');
      const data = {
        number: val,
        queryType: 1
      };
      vehicleTagNumber(data).then((res) => {
        if (res.code === 200) {
          this.vehicleNumberList = res.data;
        }
      });
    },
    getVehicleNumber1() {
      if (this.vehicleNumberList.length === 0) {
        const data = {
          number: '',
          queryType: 1
        };
        vehicleTagNumber(data).then((res) => {
          if (res.code === 200) {
            this.vehicleNumberList = res.data;
          }
        });
      }
    }
  }
};
</script>

<style scoped>
.printStyle {
  display: none;
}
</style>
